export default __webpack_public_path__ + "static/media/pin-white.271f842c.svg";